import {
  SerializedObituaryDetails,
  useSearchObituary,
} from '@ltvco/refresh-lib/v1';
import {
  AdvancedSearchURLParams,
  getObituarySearchParams,
} from '@ltvco/refresh-lib/v2';
import React from 'react';
interface ObituaryFetcherProps {
  searchData: AdvancedSearchURLParams;
  // eslint-disable-next-line no-unused-vars
  setObituaryResults: (results: SerializedObituaryDetails | undefined) => void;
}

export function ObituaryFetcher({
  searchData,
  setObituaryResults,
}: ObituaryFetcherProps) {
  const { data, isError, isFetched } = useSearchObituary({
    obituarySearchParams: getObituarySearchParams(searchData),
  });

  const result = data as SerializedObituaryDetails | undefined;

  if (isFetched && !isError) {
    setObituaryResults(result);
  } else {
    setObituaryResults(undefined);
  }
  return <React.Fragment />;
}
